import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0337903e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm:flex-grow bg-background" }
const _hoisted_2 = { class: "lg:container py-2 lg:py-8 flex flex-row justify-center w-full" }
const _hoisted_3 = { class: "sm:flex flex-row bg-white shadow rounded-2xl lg:p-8 justify-between items-start w-full p-8 lg:w-9/12 h-full" }
const _hoisted_4 = { class: "space-y-6" }
const _hoisted_5 = { class: "flex flex-row space-x-3 items-start" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, " Job title and Department details ", -1))
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "sm:flex flex-row justify-between lg:space-x-8 md:space-x-8 lg:space-y-0 space-y-4" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row space-x-3 items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, " Company ")
], -1))
const _hoisted_15 = { class: "w-full lg:w-5/12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1))
const _hoisted_17 = { class: "space-y-6 pt-5" }
const _hoisted_18 = { class: "flex flex-row space-x-3 items-start" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "Location ", -1))
const _hoisted_20 = { class: "block w-full" }
const _hoisted_21 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_22 = { class: "flex flex-col w-full lg:w-4/5" }
const _hoisted_23 = { class: "w-full" }
const _hoisted_24 = { class: "grid lg:grid-cols-2 grid-cols-1 sm:flex flex-row lg:p-5 mt-4 lg:mt-0 justify-center w-full lg:w-2/6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1))
const _hoisted_26 = { class: "space-y-6 pt-5" }
const _hoisted_27 = { class: "flex flex-row space-x-3 items-start" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "Description", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "text-xs sm:text-sm list-inside space-y-1" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "py-1" }, " Include at least 700 characters (requirement) "),
    /*#__PURE__*/_createElementVNode("li", { class: "py-1" }, " Format into sections and lists to improve readability "),
    /*#__PURE__*/_createElementVNode("li", { class: "py-1" }, " Avoid targeting specific demographics e.g. gender, nationality and age "),
    /*#__PURE__*/_createElementVNode("li", { class: "py-1" }, " No need to add a link to apply (one is added automatically) "),
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold py-5" }, "Remote Workers"),
    /*#__PURE__*/_createElementVNode("li", null, " Include the tools that people need for remote work, eg internet access, phone, etc. ")
  ])
], -1))
const _hoisted_30 = { class: "block w-full" }
const _hoisted_31 = { class: "py-1" }
const _hoisted_32 = { class: "flex flex-row items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold" }, "Description", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-white mx-4" }, null, -1))
const _hoisted_35 = { class: "py-1" }
const _hoisted_36 = { class: "flex flex-row items-center" }
const _hoisted_37 = { class: "text-sm font-bold" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-white mx-4" }, null, -1))
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1))
const _hoisted_41 = { class: "space-y-6 pt-5" }
const _hoisted_42 = { class: "flex flex-row space-x-3 items-start" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, " Employment details ", -1))
const _hoisted_44 = { class: "block w-full" }
const _hoisted_45 = { class: "sm:flex flex-row" }
const _hoisted_46 = { class: "sm:pr-5 py-3 w-full sm:w-3/6" }
const _hoisted_47 = { class: "sm:pl-5 py-3 w-full sm:w-3/6" }
const _hoisted_48 = { class: "sm:flex flex-row" }
const _hoisted_49 = { class: "sm:pr-5 py-3 w-full sm:w-3/6" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1))
const _hoisted_51 = { class: "space-y-6 pt-5" }
const _hoisted_52 = { class: "flex flex-row space-x-3 items-start" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "Skills", -1))
const _hoisted_54 = { class: "flex flex-col" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Required", -1))
const _hoisted_56 = { class: "flex w-full my-2 flex-row justify-start" }
const _hoisted_57 = {
  key: 0,
  class: "w-full rounded-lg p-3 items-center text-center"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 italic" }, "Skill not found", -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "flex flex-row flex-wrap my-6" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "text-cyan-500" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6 text-cyan-500 ml-2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v12m6-6H6"
  })
], -1))
const _hoisted_64 = { class: "text-primary flex flex-row font-medium" }
const _hoisted_65 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5 h-5 text-white ml-2 bg-purple-600 rounded-full"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 6v12m6-6H6"
}, null, -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = {
  key: 1,
  class: "w-5 h-5 text-white ml-2 bg-purple-600 rounded-full",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z"
}, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12"
}, null, -1))
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-px bg-gray-200 my-8" }, null, -1))
const _hoisted_73 = { class: "flex flex-col" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nice to have", -1))
const _hoisted_75 = { class: "flex flex-row flex-wrap" }
const _hoisted_76 = { class: "flex w-full my-2 flex-row justify-start" }
const _hoisted_77 = { class: "flex flex-row flex-wrap my-6" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "text-cyan-500" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6 text-cyan-500 ml-2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 6v12m6-6H6"
  })
], -1))
const _hoisted_81 = { class: "text-primary flex flex-row font-medium" }
const _hoisted_82 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5 h-5 text-white ml-2 bg-purple-600 rounded-full"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 6v12m6-6H6"
}, null, -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = {
  key: 1,
  class: "w-5 h-5 text-white ml-2 bg-purple-600 rounded-full",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  stroke: "none",
  d: "M0 0h24v24H0z"
}, null, -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12"
}, null, -1))
const _hoisted_88 = [
  _hoisted_86,
  _hoisted_87
]
const _hoisted_89 = {
  key: 0,
  class: "w-full rounded-lg p-3 items-center text-center"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 italic" }, "Skill not found", -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1))
const _hoisted_93 = { class: "space-y-6 pt-5" }
const _hoisted_94 = { class: "flex flex-row justify-between space-x-3 items-start items-center" }
const _hoisted_95 = { class: "space-x-2" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-bold" }, "Annual salary", -1))
const _hoisted_97 = { class: "flex flex-row justify-between space-x-4" }
const _hoisted_98 = { class: "rounded-lg flex flex-row justify-between items-center p-1" }
const _hoisted_99 = { class: "block w-full" }
const _hoisted_100 = { class: "sm:flex sm:flex-col lg:flex-row justify-between" }
const _hoisted_101 = { class: "sm:pr-5 py-3 w-full lg:w-1/3" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Minimum "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "(Required)")
], -1))
const _hoisted_103 = { class: "mt-2" }
const _hoisted_104 = { class: "sm:pr-5 py-3 w-full lg:w-1/3" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Maximun "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "(Required)")
], -1))
const _hoisted_106 = { class: "mt-2" }
const _hoisted_107 = { class: "sm:pr-5 py-3 w-full lg:w-1/3" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Currency "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "(Required)")
], -1))
const _hoisted_109 = { class: "mt-2" }
const _hoisted_110 = {
  key: 0,
  class: "p-2 animate__animated animate__fadeIn"
}
const _hoisted_111 = { class: "bg-purple-50 p-3 flex flex-col rounded-r-lg" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-purple-500 font-semibold" }, [
  /*#__PURE__*/_createTextVNode("Note: "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-light" }, "The anual salary will be displayed as: ")
], -1))
const _hoisted_113 = { class: "text-purple-600 text-lg font-semibold mt-2" }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Monthly ")
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1))
const _hoisted_117 = { class: "pt-5 block w-full" }
const _hoisted_118 = { class: "flex flex-row justify-between" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-x-4 w-1/2 flex items-center" }, null, -1))
const _hoisted_120 = {
  key: 0,
  class: "space-x-4 w-1/2 flex justify-end items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_AutocompleteLocation = _resolveComponent("AutocompleteLocation")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Bullets = _resolveComponent("Bullets")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_CurrencyField = _resolveComponent("CurrencyField")!
  const _component_Button = _resolveComponent("Button")!
  const _component_WorkFlowFields = _resolveComponent("WorkFlowFields")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["stop"])),
          class: "w-full"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Tooltip, {
                bgColor: "bg-gray-50",
                type: "list",
                liItems: _ctx.labelsTitle
              }, null, 8, ["liItems"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_TextField, {
                modelValue: _ctx.jobTitle,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jobTitle) = $event)),
                label: "Job title",
                typeInput: "text",
                required: "",
                name: "title"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.department,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.department) = $event)),
                    options: _ctx.optionDepartament,
                    label: "Select a department...",
                    typeInput: "text",
                    name: "department"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.internalCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalCode) = $event)),
                    label: "Internal code",
                    typeInput: "number",
                    name: "department_code"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.jobFunction,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.jobFunction) = $event)),
                    options: _ctx.jobFunctions,
                    label: "Select a job function...",
                    typeInput: "text",
                    name: "job_function_id"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ]),
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_DropDown, {
                modelValue: _ctx.company_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company_id) = $event)),
                options: _ctx.companies,
                label: "Select a company...",
                name: "company_id",
                disabled: _ctx.$route.params.id
              }, null, 8, ["modelValue", "options", "disabled"])
            ]),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_Tooltip, {
                bgColor: "bg-gray-50",
                type: "list",
                liItems: _ctx.labelsLocation
              }, null, 8, ["liItems"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_AutocompleteLocation, {
                      "onUpdate:modelValue": _ctx.updateHandler,
                      locationName: _ctx.jobLocationName
                    }, null, 8, ["onUpdate:modelValue", "locationName"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.preferredWork,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.preferredWork) = $event)),
                    options: _ctx.preferredWorkType,
                    label: "Select preferred work",
                    typeInput: "text",
                    name: "preferred_work"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ]),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_Tooltip, { bgColor: "bg-gray-50" }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _hoisted_34,
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-sm text-primary",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openTemplates('DescriptionTemplates')))
                  }, " Import from templates ")
                ])
              ]),
              _createVNode(_component_TextArea, {
                modelValue: _ctx.description,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.description) = $event)),
                placeholder: "Enter the job description here; include general information about the job.",
                name: "description"
              }, null, 8, ["modelValue"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textAreaData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "block w-full"
              }, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(item.label), 1),
                    _hoisted_38,
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-sm text-primary",
                      onClick: ($event: any) => (_ctx.openTemplates(item.render))
                    }, _toDisplayString(item.buttonText), 9, _hoisted_39)
                  ])
                ]),
                _createVNode(_component_Bullets, {
                  modelValue: item.model,
                  "onUpdate:modelValue": ($event: any) => ((item.model) = $event),
                  onSetDefault: item.default,
                  placeholder: item.placeholder
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onSetDefault", "placeholder"])
              ]))
            }), 128)),
            _hoisted_40
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode(_component_Tooltip, {
                bgColor: "bg-gray-50",
                type: "list",
                liItems: _ctx.labelsDetails
              }, null, 8, ["liItems"])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.employmentType,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.employmentType) = $event)),
                    options: _ctx.optionsEmployment,
                    label: "Select employment type...",
                    typeInput: "text",
                    name: "employment_type"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.experience,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.experience) = $event)),
                    options: _ctx.optionsExperience,
                    label: "Select experience...",
                    typeInput: "text",
                    name: "experience"
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_DropDown, {
                    modelValue: _ctx.education,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.education) = $event)),
                    options: _ctx.optionsEducation,
                    label: "Select education...",
                    typeInput: "text",
                    name: "education"
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ]),
            _hoisted_50
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createVNode(_component_Tooltip, {
                bgColor: "bg-gray-50",
                type: "list",
                liItems: _ctx.labelSkills
              }, null, 8, ["liItems"])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Search skill",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requiredSkillSearch) = $event)),
                  onKeyup: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.filterSkillsRequired && _ctx.filterSkillsRequired(...args))),
                  class: "w-1/2 bg-input-search p-3 rounded-lg focus:text-gray-800 focus:outline-none focus:ring-2 focus:ring-white"
                }, null, 544), [
                  [_vModelText, _ctx.requiredSkillSearch]
                ])
              ]),
              (_ctx.visibleSkillsRequiredSelected.length <= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_60, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSkillsRequiredSelected.slice(
                    0,
                    _ctx.arrayRequiredValue
                  ), (skill, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "flex flex-row items-center bg-cyan-100 hover:bg-cyan-200 p-2 m-2 rounded hover:cursor-pointer transition ease-in delay-100 animate__animated animate__fadeIn",
                    onClick: ($event: any) => (_ctx.pushToRequired(skill.name))
                  }, [
                    _createElementVNode("span", _hoisted_62, _toDisplayString(skill.name), 1),
                    _hoisted_63
                  ], 8, _hoisted_61))
                }), 128)),
                (_ctx.requiredSkillSearch.length <= 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "flex flex-row items-center bg-primary-light py-2 px-3 m-2 rounded hover:cursor-pointer transition ease-in delay-100 animate__animated animate__fadeIn text-base",
                      onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.showMoreRequiredSkills()), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.visibleSkillsRequired.length >= _ctx.arrayRequiredValue
                        ? "Show more"
                        : "Show less"), 1),
                      (_ctx.visibleSkillsRequired.length >= _ctx.arrayRequiredValue)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_65, _hoisted_67))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_68, _hoisted_71))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_Chips, {
                chips: _ctx.requiredSkills,
                placeholder: "New skill",
                class: "mt-2",
                skills: true
              }, null, 8, ["chips"])
            ]),
            _hoisted_72,
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Search skill",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.nicetohaveSkillSearch) = $event)),
                    onKeyup: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.filterSkillsNicetohave && _ctx.filterSkillsNicetohave(...args))),
                    class: "w-1/2 bg-input-search p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
                  }, null, 544), [
                    [_vModelText, _ctx.nicetohaveSkillSearch]
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSkillsNicetohaveSelected.slice(
                      0,
                      _ctx.arrayNiceHaveValue
                    ), (skill, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "flex flex-row items-center bg-cyan-100 hover:bg-cyan-200 p-2 m-2 rounded hover:cursor-pointer transition ease-in delay-100 animate__animated animate__fadeIn",
                      onClick: ($event: any) => (_ctx.pushToNiceToHave(skill.name))
                    }, [
                      _createElementVNode("span", _hoisted_79, _toDisplayString(skill.name), 1),
                      _hoisted_80
                    ], 8, _hoisted_78))
                  }), 128)),
                  (_ctx.nicetohaveSkillSearch.length <= 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "flex flex-row items-center bg-primary-light py-2 px-3 m-2 rounded hover:cursor-pointer transition ease-in delay-100 animate__animated animate__fadeIn text-base",
                        onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.showMoreNiceHaveSkills()), ["prevent"]))
                      }, [
                        _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.visibleSkillsNiceToHave.length >= _ctx.arrayNiceHaveValue
                          ? "Show more"
                          : "Show less"), 1),
                        (
                        _ctx.visibleSkillsNiceToHave.length >= _ctx.arrayNiceHaveValue
                      )
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_82, _hoisted_84))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_85, _hoisted_88))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.visibleSkillsNicetohaveSelected.length <= 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, _hoisted_91))
                  : _createCommentVNode("", true),
                _createVNode(_component_Chips, {
                  chips: _ctx.niceToHaveSkills,
                  placeholder: "New skill",
                  class: "mt-2",
                  skills: true
                }, null, 8, ["chips"])
              ])
            ]),
            _hoisted_92
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _hoisted_96,
                _createVNode(_component_Tooltip, {
                  bgColor: "bg-gray-50",
                  type: "list",
                  liItems: _ctx.labelSalary
                }, null, 8, ["liItems"])
              ]),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("span", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setSalaryType('bruto'))),
                    class: _normalizeClass(["p-1 rounded-l-lg text-sm transition-all delay-150 ease-linear cursor-pointer px-3 border border-primary", [
                      _ctx.salaryType === 'bruto'
                        ? 'bg-primary  text-white'
                        : 'bg-primary-light text-primary',
                    ]])
                  }, "Gross salary", 2),
                  _createElementVNode("span", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setSalaryType('neto'))),
                    class: _normalizeClass(["p-1 rounded-r-lg text-sm transition-all delay-150 ease-linear cursor-pointer px-3 border border-primary", [
                      _ctx.salaryType === 'neto'
                        ? 'bg-primary  text-white '
                        : 'bg-primary-light text-primary',
                    ]])
                  }, "Net salary", 2)
                ]),
                _createVNode(_component_CheckBox, {
                  label: "Show monthly salary",
                  fieldId: "salaryMonthly",
                  textSize: "font-semibold ",
                  checked: _ctx.salaryMonthly,
                  "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.salaryMonthly) = $event))
                }, null, 8, ["checked"])
              ])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("div", _hoisted_103, [
                    _createVNode(_component_CurrencyField, {
                      modelValue: _ctx.fromSalary,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.fromSalary) = $event)),
                      label: "Min",
                      name: "salary_min"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _hoisted_105,
                  _createElementVNode("div", _hoisted_106, [
                    _createVNode(_component_CurrencyField, {
                      modelValue: _ctx.toSalary,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.toSalary) = $event)),
                      label: "Max",
                      name: "salary_max"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _hoisted_108,
                  _createElementVNode("div", _hoisted_109, [
                    _createVNode(_component_DropDown, {
                      options: _ctx.optionCurrencies,
                      modelValue: _ctx.currencySalary,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.currencySalary) = $event)),
                      label: "Select currency...",
                      typeInput: "text",
                      name: "currency_salary"
                    }, null, 8, ["options", "modelValue"])
                  ])
                ])
              ]),
              (_ctx.salaryMonthly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                    _createElementVNode("div", _hoisted_111, [
                      _hoisted_112,
                      _createElementVNode("span", _hoisted_113, [
                        _createTextVNode(" $ " + _toDisplayString(_ctx.numberFormattedWithCommas(_ctx.fromSalary / 12)) + " - $ " + _toDisplayString(_ctx.numberFormattedWithCommas(_ctx.toSalary / 12)) + " ", 1),
                        (_ctx.currencySalary)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_114, "(" + _toDisplayString(_ctx.getCurrencyCode(_ctx.currencySalary)) + ") ", 1))
                          : _createCommentVNode("", true),
                        _hoisted_115
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_116
          ]),
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("div", _hoisted_118, [
              _hoisted_119,
              (_ctx.status === 'draft' && _ctx.count === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                    _createVNode(_component_Button, {
                      variant: "",
                      label: "Edit workflow",
                      onOnClick: _ctx.openWorkFlow
                    }, null, 8, ["onOnClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_ReusableModal, {
            show: _ctx.showModal,
            onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showModal = false)),
            size: "w-11/12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_WorkFlowFields, {
                onCloseWorkflow: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showModal = false)),
                countSubmit: _ctx.submitCount
              }, null, 8, ["countSubmit"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_ReusableModal, {
            show: _ctx.showModalTemplate,
            onClose: _ctx.closeModalTemplate,
            size: "w-1/2"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.renderOption), {
                onCloseModal: _ctx.closeModalTemplate,
                onAddToInput: _ctx.addToInput
              }, null, 8, ["onCloseModal", "onAddToInput"]))
            ]),
            _: 1
          }, 8, ["show", "onClose"])
        ], 32)
      ])
    ])
  ]))
}